import { useQuery } from '@hooks/reactQuery';

import { extractQueryParams } from '@utils/common';

import { IActiveAlarmOran } from '@interfaces/alarms/alarm';

import { ACTIVE_ALARM_ORAN } from '@constants/queryKeys';

interface IUseQueryActiveOranAlarmReturn {
	alarm: IActiveAlarmOran | null;
	isLoadingAlarm: boolean;
}

export const useQueryActiveOranAlarm = (
	id: string,
	queryFn: (id: string) => Promise<any>,
): IUseQueryActiveOranAlarmReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ACTIVE_ALARM_ORAN, id],
		queryFn: extractQueryParams(queryFn),
		enabled: [id],
		refetchOnWindowFocus: false,
	});

	return {
		alarm: data,
		isLoadingAlarm: isInitialLoading,
	};
};
